import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const pages = {
  '/': ['Charly Cardeno | Product Manager', 'Helping non-technical founders lead their development teams with confidence. Explore my work and book an assessment call.'],
  '/guest-speaker-event': ['Guest Speaker | Charly Cardeno', 'Lessons and reflections from Navigating Entrepreneurship Challenges, a guest speaking event with Charly Cardeno.'],
  '/academic-changemaker-recognition': ['Academic Changemaker | Charly Cardeno', 'Academic recognition for Charly Cardeno’s contributions to engineering education and industry collaboration.'],
  '/delivery-system-case-study': ['Delivery System Case Study | Charly Cardeno', 'How a points-based delivery system improved planning, accountability, and team performance.'],
  '/public-speaking': ['Alumni Panel: 20 Years of Systems Engineering | Charly Cardeno', 'Charly Cardeno joins Universidad de Cartagena’s alumni panel celebrating 20 years of Systems Engineering and exploring AI’s impact on software careers.'],
  '/privacy': ['Privacy Notice | Charly Cardeno', 'How this portfolio uses analytics, browser storage, and information you share when contacting Charly Cardeno.'],
};
export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const [title, description] = pages[pathname] || ['Page Not Found | Charly Cardeno', 'This page could not be found. Return to Charly Cardeno’s portfolio.'];
    document.title = title;
    function meta(attribute, name, content) {
      let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
      element.content = content;
    }
    meta('name', 'description', description);
    meta('name', 'robots', pages[pathname] ? 'index,follow' : 'noindex,follow');
    ['og', 'twitter'].forEach(prefix => {
      meta('property', `${prefix}:title`, title);
      meta('property', `${prefix}:description`, description);
      meta('property', `${prefix}:url`, `https://ccardenoc.com${pathname}`);
    });
  }, [pathname]);
  return null;
}
